import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
} from "@mui/lab";
import { Box, Pagination, Stack, TextField, Typography } from "@mui/material";
import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { dispatch } from "store";
import {
  getMainStockLogsThunk,
  mainStockLogSelector,
} from "store/reducers/inventory/stock/mainStockSlice";
import UTurnLeftIcon from "@mui/icons-material/UTurnLeft";
import NorthIcon from "@mui/icons-material/North";
import SouthIcon from "@mui/icons-material/South";
import ReplayIcon from "@mui/icons-material/Replay";
import {
  DesktopDateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { Link, useNavigate } from "react-router-dom";

const MainStockLogs = () => {
  const [page, setPage] = useState(1);
  const pageCount = useSelector((state) => state.mainStock.logPageCount);
  const logs = useSelector(mainStockLogSelector.selectAll);
  const [filter, setFilter] = useState({ from_date: null, to_date: null });
  const navigate = useNavigate();

  const getMainStockLogs = useCallback(() => {
    dispatch(
      getMainStockLogsThunk({
        page,
        from_date: moment(filter.from_date).isValid()
          ? moment(filter.from_date).toISOString()
          : "",
        to_date: moment(filter.to_date).isValid()
          ? moment(filter.to_date).toISOString()
          : "",
      })
    );
  }, [filter.from_date, filter.to_date, page]);
  useEffect(() => {
    getMainStockLogs();
  }, [getMainStockLogs, page]);

  const handlePageChange = (event, value) => {
    setPage(value);
    getMainStockLogs();
  };
  const getTimeDot = (direction) => {
    switch (direction) {
      case "in":
        return (
          <TimelineDot variant="filled" color="success">
            <SouthIcon fontSize="small" />
          </TimelineDot>
        );
      case "out":
        return (
          <TimelineDot variant="filled" color="info">
            <NorthIcon fontSize="small" />
          </TimelineDot>
        );
      default:
        return (
          <TimelineDot variant="filled" color="warning">
            <ReplayIcon fontSize="small" />
          </TimelineDot>
        );
    }
  };
  return (
    <Box padding={2}>
      <Stack direction="row" justifyContent="center" spacing={1.5}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DesktopDateTimePicker
            label="From date"
            value={filter.from_date}
            onChange={(value) =>
              // setFromDate(value)
              setFilter({ ...filter, from_date: value })
            }
            renderInput={(params) => (
              <TextField variant="outlined" {...params} />
            )}
          />
        </LocalizationProvider>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DesktopDateTimePicker
            label="To date"
            value={filter.to_date}
            onChange={(value) => setFilter({ ...filter, to_date: value })}
            renderInput={(params) => (
              <TextField variant="outlined" {...params} />
            )}
          />
        </LocalizationProvider>
      </Stack>
      <Typography color="text.secondary" sx={{ textAlign: "center", mt: 2 }}>
        {" "}
        * Click on date to view stock snapshot{" "}
      </Typography>
      <Timeline position="right">
        {logs.map((log) => (
          <TimelineItem key={log.id}>
            <TimelineOppositeContent
              color="text.secondary"
              
            >
              <Typography
                color="text.secondary"
                component={Link}
                to={`/main-stock/history/${moment(log.date).toISOString()}`}
                sx={{textDecoration:"none"}}
              >
                {" "}
                {moment(log.date).format("MMMM Do YYYY, h:mm:ss a")}{" "}
              </Typography>
            </TimelineOppositeContent>
            <TimelineSeparator>
              {getTimeDot(log.in_or_out)}
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
              <Stack direction="column">
                <Typography variant="h6" component="span">
                  {log.name}
                </Typography>
                <Typography variant="caption">
                  {log.qty} Nos, {log.price} Rs per item
                </Typography>
                {log.in_or_out === "out" && (
                  <Typography variant="subtitle1" component="span">
                    [Delivered to {log.distributor_name}]
                  </Typography>
                )}
                {log.in_or_out === "in" && log.distributor_name && (
                  <Typography variant="subtitle1" component="span">
                    [Returned from {log.distributor_name}]
                  </Typography>
                )}
              </Stack>
            </TimelineContent>
          </TimelineItem>
        ))}
      </Timeline>
      <Stack direction="row" justifyContent="center">
        <Pagination
          count={pageCount}
          variant="outlined"
          shape="rounded"
          onChange={handlePageChange}
        />
      </Stack>
    </Box>
  );
};

export default MainStockLogs;
